/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimPipeline,
  ClaimPipelineListResponse,
  CreateClaimPipelineRequest,
  ErrorEnvelope,
  Problem,
  UpdateClaimPipelineRequest,
} from '../models/index';
import {
    ClaimPipelineFromJSON,
    ClaimPipelineToJSON,
    ClaimPipelineListResponseFromJSON,
    ClaimPipelineListResponseToJSON,
    CreateClaimPipelineRequestFromJSON,
    CreateClaimPipelineRequestToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    UpdateClaimPipelineRequestFromJSON,
    UpdateClaimPipelineRequestToJSON,
} from '../models/index';

export interface CreateClaimPipelineOperationRequest {
    createClaimPipelineRequest: CreateClaimPipelineRequest;
}

export interface DeleteClaimPipelineRequest {
    id: number;
}

export interface GetClaimPipelineRequest {
    id: number;
}

export interface GetClaimPipelinesRequest {
    includeInactive?: boolean;
}

export interface UpdateClaimPipelineOperationRequest {
    id: number;
    updateClaimPipelineRequest: UpdateClaimPipelineRequest;
}

/**
 * ClaimPipelinesApi - interface
 * 
 * @export
 * @interface ClaimPipelinesApiInterface
 */
export interface ClaimPipelinesApiInterface {
    /**
     * 
     * @summary Create a new claim pipeline
     * @param {CreateClaimPipelineRequest} createClaimPipelineRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimPipelinesApiInterface
     */
    createClaimPipelineRaw(requestParameters: CreateClaimPipelineOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPipeline>>;

    /**
     * Create a new claim pipeline
     */
    createClaimPipeline(requestParameters: CreateClaimPipelineOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPipeline>;

    /**
     * 
     * @summary Delete a claim pipeline (blocked if any claims still use it)
     * @param {number} id Claim pipeline ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimPipelinesApiInterface
     */
    deleteClaimPipelineRaw(requestParameters: DeleteClaimPipelineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a claim pipeline (blocked if any claims still use it)
     */
    deleteClaimPipeline(requestParameters: DeleteClaimPipelineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get a claim pipeline by ID
     * @param {number} id Claim pipeline ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimPipelinesApiInterface
     */
    getClaimPipelineRaw(requestParameters: GetClaimPipelineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPipeline>>;

    /**
     * Get a claim pipeline by ID
     */
    getClaimPipeline(requestParameters: GetClaimPipelineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPipeline>;

    /**
     * 
     * @summary Get all claim pipelines for the company
     * @param {boolean} [includeInactive] When true, inactive pipelines are also returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimPipelinesApiInterface
     */
    getClaimPipelinesRaw(requestParameters: GetClaimPipelinesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPipelineListResponse>>;

    /**
     * Get all claim pipelines for the company
     */
    getClaimPipelines(requestParameters: GetClaimPipelinesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPipelineListResponse>;

    /**
     * 
     * @summary Update a claim pipeline
     * @param {number} id Claim pipeline ID
     * @param {UpdateClaimPipelineRequest} updateClaimPipelineRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimPipelinesApiInterface
     */
    updateClaimPipelineRaw(requestParameters: UpdateClaimPipelineOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPipeline>>;

    /**
     * Update a claim pipeline
     */
    updateClaimPipeline(requestParameters: UpdateClaimPipelineOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPipeline>;

}

/**
 * 
 */
export class ClaimPipelinesApi extends runtime.BaseAPI implements ClaimPipelinesApiInterface {

    /**
     * Create a new claim pipeline
     */
    async createClaimPipelineRaw(requestParameters: CreateClaimPipelineOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPipeline>> {
        if (requestParameters['createClaimPipelineRequest'] == null) {
            throw new runtime.RequiredError(
                'createClaimPipelineRequest',
                'Required parameter "createClaimPipelineRequest" was null or undefined when calling createClaimPipeline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-pipelines`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClaimPipelineRequestToJSON(requestParameters['createClaimPipelineRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimPipelineFromJSON(jsonValue));
    }

    /**
     * Create a new claim pipeline
     */
    async createClaimPipeline(requestParameters: CreateClaimPipelineOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPipeline> {
        const response = await this.createClaimPipelineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a claim pipeline (blocked if any claims still use it)
     */
    async deleteClaimPipelineRaw(requestParameters: DeleteClaimPipelineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteClaimPipeline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-pipelines/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a claim pipeline (blocked if any claims still use it)
     */
    async deleteClaimPipeline(requestParameters: DeleteClaimPipelineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimPipelineRaw(requestParameters, initOverrides);
    }

    /**
     * Get a claim pipeline by ID
     */
    async getClaimPipelineRaw(requestParameters: GetClaimPipelineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPipeline>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getClaimPipeline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-pipelines/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimPipelineFromJSON(jsonValue));
    }

    /**
     * Get a claim pipeline by ID
     */
    async getClaimPipeline(requestParameters: GetClaimPipelineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPipeline> {
        const response = await this.getClaimPipelineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all claim pipelines for the company
     */
    async getClaimPipelinesRaw(requestParameters: GetClaimPipelinesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPipelineListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['includeInactive'] != null) {
            queryParameters['includeInactive'] = requestParameters['includeInactive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-pipelines`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimPipelineListResponseFromJSON(jsonValue));
    }

    /**
     * Get all claim pipelines for the company
     */
    async getClaimPipelines(requestParameters: GetClaimPipelinesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPipelineListResponse> {
        const response = await this.getClaimPipelinesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a claim pipeline
     */
    async updateClaimPipelineRaw(requestParameters: UpdateClaimPipelineOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPipeline>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateClaimPipeline().'
            );
        }

        if (requestParameters['updateClaimPipelineRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClaimPipelineRequest',
                'Required parameter "updateClaimPipelineRequest" was null or undefined when calling updateClaimPipeline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-pipelines/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClaimPipelineRequestToJSON(requestParameters['updateClaimPipelineRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimPipelineFromJSON(jsonValue));
    }

    /**
     * Update a claim pipeline
     */
    async updateClaimPipeline(requestParameters: UpdateClaimPipelineOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPipeline> {
        const response = await this.updateClaimPipelineRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
